import {Service} from './Service';

export class AuthService extends Service {

  static entity: string = 'iam-auth';

  static getToken(): Promise<any> {
    return this.axios.get(`${this.entity}/token`).then(res => res.data);
  }

  static getApiKey(): Promise<any> {
    return this.axios.get(`${this.entity}/api-key`).then(res => res.data);
  }

  static login(username: string, password: string): Promise<any> {
    return this.axios.post(`${this.entity}/login`, {username, password}).then(res => res.data);
  }

  static logout(): Promise<any> {
    return this.axios.post(`${this.entity}/logout`).then(res => res.data);
  }

  static ssoLogout(): Promise<any> {
    return this.axios.post('iam-sso/keycloak-oidc/logout').then(res => res.data);
  }

  static changePassword(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/change-password`, data).then(res => res.data);
  }

  static resetPassword(username: string, emailAddress: string): Promise<any> {
    return this.axios.put(`${this.entity}/reset-password`, {username, emailAddress}).then(res => res.data);
  }

  static getSsoLoginUrl(): Promise<any> {
    return this.axios.get('iam-sso/keycloak-oidc/login-url').then(res => res.data);
  }

  static exchangeSsoCode(code: string, sessionState?: string, redirectUri?: string): Promise<any> {
    return this.axios.post('iam-sso/keycloak-oidc/exchange-code-to-access-token', {
      code,
      session_state: sessionState,
      redirect_uri: redirectUri
    }).then(res => res.data);
  }

  static getMe(): Promise<any> {
    return this.axios.get('iam-common/me').then(res => res.data);
  }

}

export enum Role {
  Administrator = 'Administrator',
  Editor = 'Editor',
  Viewer = 'Viewer'
}
